import React from 'react';

import expertise from '@images/golang-development/our-approach/expertise.svg';
import experience from '@images/golang-development/our-approach/experience.svg';
import flexibleTeams from '@images/golang-development/our-approach/flexibleTeams.svg';
import goalOrientation from '@images/golang-development/our-approach/goalOrientation.svg';
import support from '@images/golang-development/our-approach/support.svg';
import partnership from '@images/golang-development/our-approach/partnership.svg';

export const ourApproachData = {
  firstParagraph: (
    <>
      At CodiLime, we believe that <span className="bold-font">good communication is the first step to success.</span>
      That&apos;s why knowing your needs, team resources and documentation allows us to evaluate your project and design
      the appropriate support. We can also{' '}
      <span className="bold-font">better match our engineers to the project requirements</span> to take as much of the
      load off your shoulders as possible.
    </>
  ),
  secondParagraph: 'What else can you expect from us?',
  methods: [
    {
      src: expertise,
      subtitle: 'Expertise in building custom solutions',
      get alt() {
        return this.subtitle;
      },
    },
    {
      src: experience,
      subtitle: 'Hands-on experience with network engineering',
      get alt() {
        return this.subtitle;
      },
    },
    {
      src: flexibleTeams,
      subtitle: 'Flexible and easy-to-scale teams',
      get alt() {
        return this.subtitle;
      },
    },
    {
      src: goalOrientation,
      subtitle: 'Goal orientation and on time delivery',
      get alt() {
        return this.subtitle;
      },
    },
    {
      src: support,
      subtitle: 'Support through the entire SDLC',
      get alt() {
        return this.subtitle;
      },
    },
    {
      src: partnership,
      subtitle: 'Focus on long-term partnership',
      get alt() {
        return this.subtitle;
      },
    },
  ],
};
